import NoIcon from '@root/assets/svg/Status/NoIcon';
import YesIcon from '@root/assets/svg/Status/YesIcon';
import React from 'react';
import './style.scss';

const YesNo = ({ yes }: { yes: boolean; no: boolean }) => {
  if (yes) {
    return (
      <div className="YesNo__Container">
        <YesIcon />
        Yes
      </div>
    );
  }

  return (
    <div className="YesNo__Container">
      <NoIcon />
      No
    </div>
  );
};

export default YesNo;
